import HTMLReactParser from "html-react-parser";

function ShowHtmlContent({ content }) {
  const decordedContent = decodeURI(content);

  return HTMLReactParser(decordedContent);
}

export default ShowHtmlContent;
